import { render, staticRenderFns } from "./FileDriveIndexView.vue?vue&type=template&id=c0879cf6&"
import script from "./FileDriveIndexView.vue?vue&type=script&lang=js&"
export * from "./FileDriveIndexView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports